import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPlay = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M28.522 13.36c.667.413 1.112.89 1.367 1.557.254.7.254 1.399 0 2.066-.255.7-.7 1.176-1.367 1.59L6.497 31.57c-.635.381-1.335.508-2.002.381-.7-.127-1.335-.445-1.812-.985-.508-.572-.762-1.208-.762-1.97V2.967c0-.794.254-1.493.762-2.002A3.415 3.415 0 0 1 4.495.043c.667-.127 1.271.032 1.875.382z" /></svg>;
export default SvgPlay;